/* Ilgili icerik motoru (tam otomatik; admin'de etiket/metafield gerekmez).
 *
 * MIMARI GARANTI: kart SAYISINI sunucu belirler (kalori 8, blog 4) ve motor
 * karti ASLA azaltmaz - yalnizca siralamayi iyilestirir. Guclu sonuc azsa
 * liste sunucunun bastigi kartlarla ayni sayiya tamamlanir. JS kapali/hatali
 * iken sunucu listesi oldugu gibi kalir (SEO linkleri ilk HTML'dedir).
 *
 * Iki kip:
 *  - food (Kalori Cetveli): foods-tr.json group/subgroup + yip-food-group-map
 *    icindeki komsuluk bolumu (tek kaynak) ile kademeli benzerlik:
 *    ayni alt grup > ayni grup > komsu grup > makro yakinligi. Deterministik.
 *  - text (normal blog): MiniSearch (baslik x4 / ozet x2, Turkce normalize +
 *    durak + kokleme + esanlam) + Shopify predictive search
 *    (/search/suggest.json, tam icerikte arar; havuz 150 siniri boyle asilir)
 *    + sunucu yedegi. "K vitamini" gibi harf+vitamin kaliplari tek konu
 *    belirteci olarak katlanir (kvitamin) - tek harf durak filtresine takilmaz.
 *
 * URL hijyeni: onerilere yalnizca temiz kanonik yol yazilir (_pos/_psq/_ss
 * gibi arama parametreleri atilir) ve yalnizca ayni blogun yollari kabul edilir.
 */
(function () {
  'use strict';

  var TR_MAP = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'İ': 'i', 'I': 'i', 'Ç': 'c', 'Ğ': 'g', 'Ö': 'o', 'Ş': 's', 'Ü': 'u' };
  function trNorm(s) {
    return String(s || '').replace(/[çğıöşüİIÇĞÖŞÜ]/g, function (c) { return TR_MAP[c] || c; }).toLowerCase();
  }

  // "k vitamini" / "b12 vitamini" tek belirtece katlanir; tek harf kaybolmaz.
  function foldVitamins(s) {
    return trNorm(s).replace(/\b([a-z])(\d{0,2})[\s-]+vitamin/g, '$1$2vitamin');
  }

  // Durak kelimeler HEM ham normalize HEM 6 karakterlik kok haliyle saklanir.
  var STOPWORDS = {};
  ('ve ile veya ama fakat ancak icin gibi kadar sonra once cok az en daha bir bu su o da de mi mu midir mudur ' +
   'ne neden nasil nedir nelerdir hangi kac olan olarak olur olabilir vardir yoktur sey seyler ' +
   'faydalari faydasi fayda zararlari zarari zarar onemi hakkinda rehber rehberi bilinmesi gereken gerekenler ' +
   'iyi kotu dogru yanlis yeni tam guncel listesi tablosu 100 gram kalori kac kaloridir besin degeri degerleri ' +
   'iceren icerir iceriyor icerigi besinler besinleri gidalar gida gidasi yiyecek yiyecekler icecek icecekler ' +
   'kaynak kaynagi kaynaklari zengin acisindan tuketim tuketimi tuketilmeli tuketilir arasindaki iliskisi ' +
   'etkisi etkileri sekilde yontem yontemleri oneriler onerileri saglikli saglik beslenme beslenmede ' +
   'vucut vucudumuz gunluk gunde miktar miktari ihtiyaci ihtiyac alinmali almali kullanimi kullanilir nelere')
    .split(' ').forEach(function (w) { STOPWORDS[w] = true; STOPWORDS[w.slice(0, 6)] = true; });

  // Konu esanlam/genisletme sozlugu (sorgu tarafinda uygulanir).
  var EXPAND = {
    demir: ['mineral', 'kansizlik', 'anemi'],
    cinko: ['mineral', 'bagisiklik'],
    selenyum: ['mineral', 'bagisiklik'],
    potasyum: ['mineral', 'tansiyon'],
    fosfor: ['mineral', 'kemik'],
    iyot: ['mineral', 'tiroit'],
    kalsiyum: ['kemik', 'mineral'],
    magnezyum: ['mineral', 'kas'],
    probiyotik: ['sindirim', 'bagirsak', 'flora'],
    prebiyotik: ['sindirim', 'bagirsak', 'lif'],
    gluten: ['colyak', 'glutensiz'],
    colyak: ['gluten', 'glutensiz'],
    protein: ['kas', 'amino'],
    kolajen: ['cilt', 'eklem'],
    omega: ['balik', 'yag asidi'],
    vitamin: ['mineral', 'takviye'],
    vegan: ['bitkisel', 'vejetaryen'],
    diyet: ['zayiflama', 'kilo'],
    zayiflama: ['diyet', 'kilo'],
    seker: ['diyabet', 'insulin'],
    diyabet: ['seker', 'insulin'],
    lif: ['sindirim', 'bagirsak'],
    bagisiklik: ['vitamin', 'savunma']
  };

  function processTerm(term) {
    var t = trNorm(term).replace(/[^a-z0-9]/g, '');
    if (t.length < 2 || STOPWORDS[t]) return null;
    t = t.length > 6 ? t.slice(0, 6) : t;
    return STOPWORDS[t] ? null : t;
  }

  /* ---------- saf yardimcilar (node testlerinde de kosulur) ---------- */

  // yip-food-group-map ciktisinin § sonrasi bolumunu {grup: {komsu:true}}
  // haritasina cevirir - komsuluk tanimi Liquid ile TEK kaynaktan gelir.
  function parseAdjacency(mapString) {
    // SIRALI dizi dondurur: listede one yazilan komsu grup daha yuksek
    // oncelik bandina girer (kola -> sut, tatlidan; tatli, meyveden once).
    var out = {};
    var part = String(mapString || '').split('§')[1] || '';
    part.split('|').forEach(function (entry) {
      var i = entry.indexOf('>');
      if (i < 1) return;
      var g = entry.slice(0, i), list = [];
      entry.slice(i + 1).split(',').forEach(function (n) { if (n) list.push(n); });
      out[g] = list;
    });
    return out;
  }

  function macroCloseness(a, b) {
    // Kalori cift agirlikli: ayni kademedeki adaylar (ornegin meyveler)
    // once kalorisi yakin olanlar gelecek sekilde siralanir; makrolar
    // ikincil sinyal olarak kalir.
    var keys = ['kcal', 'kcal', 'protein', 'carb', 'fat'];
    var s = 0;
    for (var i = 0; i < keys.length; i++) {
      var x = Number(a[keys[i]] || 0), y = Number(b[keys[i]] || 0);
      var d = Math.abs(x - y) / (x + y + 1);
      s += Math.max(0, 1 - d);
    }
    return (s / keys.length) * 40;
  }

  // Puan bantlari makro bonusuyla (0-40) CAKISMAYACAK kadar ayrik:
  // ayni alt grup 500, ayni grup 440, komsu gruplar SIRAYLA 380/320/260/200
  // (listede onde olan komsu ustun - makro bonusu bant atlatamaz), diger 0.
  function scoreFoodCandidates(current, candidates, adjacency) {
    var neighbors = (adjacency || {})[current.group] || [];
    var out = [];
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c || c.id === current.id) continue;
      var base = 0;
      if (c.subgroup === current.subgroup && c.group === current.group) base = 500;
      else if (c.group === current.group) base = 440;
      else {
        var idx = neighbors.indexOf(c.group);
        if (idx >= 0) base = 380 - Math.min(idx, 3) * 60;
      }
      out.push({ id: c.id, score: base + macroCloseness(current.per100, c.per100) });
    }
    out.sort(function (a, b) { return b.score - a.score || (a.id < b.id ? -1 : 1); });
    return out;
  }

  function anchorGate(results, anchorSet) {
    return results.filter(function (r) {
      var terms = r.terms || [];
      for (var i = 0; i < terms.length; i++) if (anchorSet[terms[i]]) return true;
      return false;
    });
  }

  function textThreshold(results) {
    if (!results.length) return [];
    var top = results[0].score;
    return results.filter(function (r) { return r.score >= Math.max(top * 0.3, 1.5); });
  }

  function cleanPath(url) {
    return String(url || '').replace(/^https?:\/\/[^/]+/, '').split('#')[0].split('?')[0];
  }

  function titleFingerprint(t) {
    var x = String(t || '');
    // Birlesik Unicode isaretleri ayristir (ornek: 'i' + combining dot) -
    // ayni basligin /cinko-iceren ve /cinko-i\u0307ceren kopyalari ayni ize duser.
    if (x.normalize) x = x.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    return trNorm(x).replace(/[^a-z0-9]/g, '');
  }

  // Predictive search icin sade konu sorgusu: basliktan durak/kalip kelimeler
  // atilir, "K" gibi tek harf yalniz ardindan "vitamin*" geliyorsa korunur.
  // "K Vitamini Iceren Besinler Nelerdir?" -> "K Vitamini".
  function topicQuery(title) {
    var words = String(title || '').split(/\s+/);
    var out = [];
    for (var i = 0; i < words.length && out.length < 5; i++) {
      var raw = words[i].replace(/[^0-9A-Za-z\u00c0-\u024f\u0130\u0131çğıöşüÇĞİÖŞÜ]/g, '');
      if (!raw) continue;
      var norm = trNorm(raw);
      if (norm.length < 2) {
        if (trNorm(words[i + 1] || '').indexOf('vitamin') === 0) out.push(raw);
        continue;
      }
      if (STOPWORDS[norm] || STOPWORDS[norm.length > 6 ? norm.slice(0, 6) : norm]) continue;
      out.push(raw);
    }
    return out.join(' ') || String(title || '');
  }

  // Kaynaklari sirayla birlestirir; ayni yol veya ayni normalize baslik
  // ikinci kez giremez; guncel yazi dislanir; limitte durur.
  function mergeUnique(sources, limit, currentPath, currentTitle) {
    var seen = {}, out = [];
    if (currentPath) seen['p:' + cleanPath(currentPath)] = true;
    // Guncel yazinin BASLIGI da bastan isaretlenir: ayni basligin baska
    // URL'deki kopyasi (cinko ornegi) onerilere giremez.
    if (currentTitle) seen['t:' + titleFingerprint(currentTitle)] = true;
    for (var s = 0; s < sources.length && out.length < limit; s++) {
      var list = sources[s] || [];
      for (var i = 0; i < list.length && out.length < limit; i++) {
        var it = list[i];
        if (!it || !it.url || !it.title) continue;
        var pk = 'p:' + cleanPath(it.url), tk = 't:' + titleFingerprint(it.title);
        if (seen[pk] || seen[tk]) continue;
        seen[pk] = true; seen[tk] = true;
        out.push({ url: cleanPath(it.url), title: it.title, image: it.image || null, date: it.date || '' });
      }
    }
    return out;
  }

  /* ---------- DOM katmani ---------- */

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Sunucunun bastigi kartlar son care dolgu kaynagi olarak saklanir.
  function snapshotGrid(grid) {
    var out = [];
    grid.querySelectorAll('.article-related-posts__item').forEach(function (a) {
      var t = a.querySelector('.article-related-posts__item-title');
      var img = a.querySelector('img');
      var d = a.querySelector('.article-related-posts__item-date');
      out.push({
        url: a.getAttribute('href') || '',
        title: t ? t.textContent : '',
        image: img ? img.getAttribute('src') : null,
        date: d ? d.textContent : ''
      });
    });
    return out;
  }

  function buildCard(item, tpl) {
    var a = tpl.cloneNode(true);
    a.setAttribute('href', item.url);
    var img = a.querySelector('img');
    if (img) {
      if (item.image) { img.src = item.image; img.alt = item.title; img.removeAttribute('srcset'); }
      else { var w = a.querySelector('.article-related-posts__image-wrapper'); if (w) w.remove(); }
    }
    var t = a.querySelector('.article-related-posts__item-title');
    if (t) t.textContent = item.title;
    var dEl = a.querySelector('.article-related-posts__item-date');
    if (dEl) { if (item.date) dEl.textContent = item.date; else dEl.remove(); }
    return a;
  }

  function replaceGrid(grid, items) {
    var tpl = grid.querySelector('.article-related-posts__item');
    if (!tpl || !items.length) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < items.length; i++) frag.appendChild(buildCard(items[i], tpl));
    grid.textContent = '';
    grid.appendChild(frag);
  }

  function runFoodMode(cfg, grid) {
    var limit = cfg.limit || 8;
    var fallback = snapshotGrid(grid);
    fetch(cfg.foodsUrl)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (foods) {
        var byId = {};
        foods.forEach(function (f) { byId[f.id] = f; });
        var current = byId[cfg.currentFoodId];
        if (!current) return;
        var haveArticle = {};
        cfg.articles.forEach(function (a) { if (a.foodId) haveArticle[a.foodId] = a; });
        var candidates = foods.filter(function (f) { return haveArticle[f.id]; });
        var adjacency = parseAdjacency(cfg.groupsMap);
        var ranked = scoreFoodCandidates(current, candidates, adjacency)
          .map(function (r) { return haveArticle[r.id]; });
        // Motor karti azaltmaz: eksik kalirsa sunucu kartlarindan tamamlanir.
        var items = mergeUnique([ranked, fallback], Math.max(limit, fallback.length), cfg.currentUrl, null);
        if (items.length >= fallback.length && items.length >= 1) replaceGrid(grid, items);
      })
      .catch(function () { /* sunucu listesi yerinde kalir */ });
  }

  function fetchPredictive(cfg) {
    var title = cfg.current && cfg.current.title;
    if (!title || !window.fetch) return Promise.resolve([]);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Sade konu sorgusu (tam baslik yalnizca sayfanin kendisini buluyordu) +
    // title,body,tag alanlari (alan verilmezse govde ARANMAZ) + kucuk
    // section yaniti (suggest.json makale govdelerini de tasiyordu).
    var u = root + 'search/suggest?q=' + encodeURIComponent(topicQuery(title)) +
      '&resources[type]=article&resources[limit]=10' +
      '&resources[options][fields]=' + encodeURIComponent('title,body,tag') +
      '&section_id=yip-related-search';
    return fetch(u)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/data-yip-related-search[^>]*>([\s\S]*?)<\/script>/);
        var arts = m ? JSON.parse(m[1]) : [];
        var prefix = '/blogs/' + cfg.blogHandle + '/';
        return arts.filter(function (a) { return a && cleanPath(a.url).indexOf(prefix) === 0; })
          .map(function (a) { return { url: cleanPath(a.url), title: a.title, image: a.image || null, date: a.date || '' }; });
      })
      .catch(function () { return []; });
  }

  function runTextMode(cfg, grid) {
    if (typeof MiniSearch === 'undefined') return;
    var limit = cfg.limit || 4;
    var fallback = snapshotGrid(grid);

    var mini = new MiniSearch({
      fields: ['title', 'excerpt'],
      storeFields: [],
      processTerm: processTerm,
      searchOptions: { boost: { title: 4, excerpt: 2 }, combineWith: 'OR', processTerm: processTerm }
    });
    var byId = {};
    var pool = [];
    cfg.articles.forEach(function (a) {
      byId[a.id] = a;
      if (a.id !== cfg.currentId) {
        pool.push({ id: a.id, title: foldVitamins(a.title), excerpt: foldVitamins(a.excerpt || '') });
      }
    });
    mini.addAll(pool);

    var qBase = foldVitamins(
      cfg.current.title + ' ' + cfg.current.title + ' ' + (cfg.current.excerpt || '') + ' ' + (cfg.current.text || '')
    ).slice(0, 1200);
    var extra = [];
    qBase.split(/[^a-z0-9]+/).forEach(function (w) { if (EXPAND[w]) extra = extra.concat(EXPAND[w]); });
    var anchorSet = {};
    (foldVitamins(cfg.current.title) + ' ' + extra.join(' ')).split(/\s+/).forEach(function (w) {
      var t = processTerm(w);
      if (t) anchorSet[t] = true;
    });

    var all = mini.search(qBase + ' ' + extra.join(' '));
    var anchored = anchorGate(all, anchorSet);
    var strong = textThreshold(anchored);
    var strongIds = {}; strong.forEach(function (r) { strongIds[r.id] = true; });
    var anchoredWeak = anchored.filter(function (r) { return !strongIds[r.id]; });
    var restIds = {}; anchored.forEach(function (r) { restIds[r.id] = true; });
    var rest = all.filter(function (r) { return !restIds[r.id]; });
    function toItems(rs) { return rs.map(function (r) { return byId[r.id]; }).filter(Boolean); }

    // Shopify predictive search tam icerikte arar; 150'lik havuzun disindaki
    // yazilari da yakalar. Basarisiz olursa bos doner, kartlar kaybolmaz.
    fetchPredictive(cfg).then(function (predictive) {
      var items = mergeUnique(
        [toItems(strong), predictive, toItems(anchoredWeak), toItems(rest), fallback],
        Math.max(limit, fallback.length),
        cfg.currentUrl,
        cfg.current.title
      );
      if (items.length >= fallback.length && items.length >= 1) replaceGrid(grid, items);
    });
  }

  function boot() {
    var cfg = readJSON('yip-related-data');
    if (!cfg) return;
    var grid = document.querySelector('.article-related-posts__grid');
    if (!grid) return;
    if (cfg.mode === 'food') runFoodMode(cfg, grid);
    else runTextMode(cfg, grid);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      trNorm: trNorm, foldVitamins: foldVitamins, processTerm: processTerm,
      macroCloseness: macroCloseness, scoreFoodCandidates: scoreFoodCandidates,
      textThreshold: textThreshold, anchorGate: anchorGate, parseAdjacency: parseAdjacency,
      mergeUnique: mergeUnique, cleanPath: cleanPath, EXPAND: EXPAND,
      titleFingerprint: titleFingerprint, topicQuery: topicQuery
    };
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})();
